// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-column[data-v-3f5e1f6f] {\n  display: none;\n}\n.table.has-sticky-header thead > tr th[data-v-3f5e1f6f] {\n  top: var(--sticky-header-top);\n}\n.header-no-border th[data-v-3f5e1f6f] {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
